<rt-button [disabled]="disabled" variant="secondary" size="small">
  <span text-primary text-bold class="bracket" margin-right-small-xx>[</span>
  <span class="text">{{ text }}</span>
  <span text-primary text-bold margin-left-small-xx class="bracket">]</span>
</rt-button>
